function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import config from 'react-global-configuration';
import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS } from '../UI';
export var COMMERCE_CART_TOKEN_GENERATED = 'COMMERCE_CART_TOKEN_GENERATED';
export var commerceCartGenerateToken = function commerceCartGenerateToken() {
  return {
    type: COMMERCE_CART_TOKEN_GENERATED,
    payload: Math.random().toString(36).substr(2)
  };
};
export var commerceFetch = function commerceFetch(path, method, data, dispatch, getState) {
  var commerceToken = getState().getIn(['commerce', 'cart', 'token']);
  if (!commerceToken) {
    dispatch(commerceCartGenerateToken());
    commerceToken = getState().getIn(['commerce', 'cart', 'token']);
  }
  var API_URL = config.get('API_URL');
  var language = getState().getIn(['ui', 'language']);
  var MULTILINGUAL = config.get('MULTILINGUAL', true);
  var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
  return fetch("".concat(PATH, "/jsonapi/").concat(path), {
    method: method,
    credentials: 'include',
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
      'Commerce-Cart-Token': commerceToken
    },
    body: data ? JSON.stringify({
      data: data
    }) : null
  });
};
export var commerceCartSetToken = function commerceCartSetToken(token) {
  return {
    type: COMMERCE_CART_TOKEN_GENERATED,
    payload: token
  };
};

// The reeived JSON:API structure appends all related entities. We would like to be able
// to access these properties easily in the frontend. This function makes them part of the
// data that is stored in the state.
var appendRelatedEntitiesRecursively = function appendRelatedEntitiesRecursively(item, entities) {
  var visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['order--default'];
  var relationships = Object.keys(item.relationships);
  relationships.forEach(function (rel) {
    if (item.relationships[rel].data && item.relationships[rel].data.type) {
      var type = item.relationships[rel].data.type;
      var id = item.relationships[rel].data.id;
      if (visited.includes(type)) {
        // We have already visited that object type in this branch, so stop.
        return;
      }
      var relationshipObject = entities.find(function (item) {
        if (item.type === type && item.id === id) {
          return item;
        }
      });
      if (relationshipObject) {
        appendRelatedEntitiesRecursively(relationshipObject, entities, [].concat(_toConsumableArray(visited), [type]));
        item.relationships[rel] = _objectSpread(_objectSpread({}, item.relationships[rel]), relationshipObject);
      }
    }
  });
};
export var COMMERCE_CART_DATA_RECEIVED = 'COMMERCE_CART_DATA_RECEIVED';
export var COMMERCE_CART_DATA_PRODUCTS_RECEIVED = 'COMMERCE_CART_DATA_PRODUCTS_RECEIVED';
export var commerceLoadCart = function commerceLoadCart() {
  return function (dispatch, getState) {
    dispatch(setOperationStatus('commerce', 'cart_load', UI_OPERATION_STATUS_REQUEST));
    commerceFetch('carts?include=order_items.purchased_entity.product_id', 'GET', null, dispatch, getState).then(function (response) {
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then(function (response) {
      dispatch({
        type: COMMERCE_CART_DATA_RECEIVED,
        payload: response.data[0]
      });

      // Get the products.
      var products = response.included ? response.included.filter(function (item) {
        return item.type === 'order-item--default';
      }) : [];

      // Recursively append all related entities.
      var productsWithInfo = products.map(function (product) {
        appendRelatedEntitiesRecursively(product, response.included);
        return product;
      });
      dispatch({
        type: COMMERCE_CART_DATA_PRODUCTS_RECEIVED,
        payload: productsWithInfo
      });
      dispatch(setOperationStatus('commerce', 'cart_load', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('commerce', 'cart_load', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var commerceCartAddProduct = function commerceCartAddProduct(productUuid) {
  var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var variation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  return function (dispatch, getState) {
    dispatch(setOperationStatus('commerce', 'cart_product_add', UI_OPERATION_STATUS_REQUEST));
    commerceFetch('cart/add?include=order_id.order_items,order_id.order_items.purchased_entity.product_id', 'POST', [{
      type: "product-variation--".concat(variation),
      id: productUuid,
      meta: {
        quantity: quantity
      }
    }], dispatch, getState).then(function (response) {
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then(function (response) {
      dispatch(commerceLoadCart());
      dispatch(setOperationStatus('commerce', 'cart_product_add', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('commerce', 'cart_product_add', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var commerceCartRemoveProduct = function commerceCartRemoveProduct(productUuid) {
  return function (dispatch, getState) {
    dispatch(setOperationStatus('commerce', 'cart_product_remove', UI_OPERATION_STATUS_REQUEST));
    var cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch("carts/".concat(cartId, "/items?include=order_id.order_items"), 'DELETE', [{
      type: 'order-item--default',
      id: productUuid
    }], dispatch, getState).then(function () {
      dispatch(commerceLoadCart());
      dispatch(setOperationStatus('commerce', 'cart_product_remove', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('commerce', 'cart_product_remove', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var commerceProductChangeQuantity = function commerceProductChangeQuantity(productUuid, quantity) {
  return function (dispatch, getState) {
    dispatch(setOperationStatus('commerce', 'cart_product_add', UI_OPERATION_STATUS_REQUEST));
    var cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch("carts/".concat(cartId, "/items/").concat(productUuid, "?include=order_id.order_items"), 'PATCH', {
      type: 'order-items--default',
      id: productUuid,
      attributes: {
        quantity: quantity
      }
    }, dispatch, getState).then(function (response) {
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then(function (response) {
      dispatch(commerceLoadCart());
      dispatch(setOperationStatus('commerce', 'cart_product_add', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('commerce', 'cart_product_add', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var commerceCartCheckout = function commerceCartCheckout() {
  return function (dispatch, getState) {
    dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_REQUEST));
    var cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch("checkout/".concat(cartId), 'GET', null, dispatch, getState).then(function (response) {
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then(function (response) {
      dispatch(commerceLoadCart());
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var commerceCartOrderSetBillingInformation = function commerceCartOrderSetBillingInformation(countryCode, locality, postalCode, addressLine1, addressLine2, givenName, familyName) {
  var organization = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var email = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  return function (dispatch, getState) {
    dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_REQUEST));
    var cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch("checkout/".concat(cartId), 'PATCH', {
      type: 'order--default',
      id: cartId,
      attributes: {
        email: email,
        billing_information: {
          address: {
            country_code: countryCode,
            locality: locality,
            postal_code: postalCode,
            address_line1: addressLine1,
            address_line2: addressLine2,
            given_name: givenName,
            family_name: familyName,
            organization: organization
          }
        }
      }
    }, dispatch, getState).then(function (response) {
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then(function (response) {
      dispatch(commerceLoadCart());
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var commerceCartOrderSetShippingInformation = function commerceCartOrderSetShippingInformation(countryCode, locality, postalCode, addressLine1, addressLine2, givenName, familyName) {
  var organization = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  return function (dispatch, getState) {
    dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_REQUEST));
    var cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch("checkout/".concat(cartId), 'PATCH', {
      type: 'order--default',
      id: cartId,
      attributes: {
        shipping_method: '1--default',
        shipping_information: {
          address: {
            country_code: countryCode,
            locality: locality,
            postal_code: postalCode,
            address_line1: addressLine1,
            address_line2: addressLine2,
            given_name: givenName,
            family_name: familyName,
            organization: organization
          }
        }
      }
    }, dispatch, getState).then(function (response) {
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then(function (response) {
      dispatch(commerceLoadCart());
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var commerceCartFinishOrder = function commerceCartFinishOrder() {
  return function (dispatch, getState) {
    dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_REQUEST));
    var cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch("checkout/".concat(cartId), 'PATCH', {
      type: 'order--default',
      id: cartId,
      attributes: {
        state: 'fulfillment'
      }
    }, dispatch, getState).then(function (response) {
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then(function (response) {
      dispatch(commerceLoadCart());
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var COMMERCE_ORDERS_DATA_RECEIVED = 'COMMERCE_ORDERS_DATA_RECEIVED';
export var commerceOrdersLoad = function commerceOrdersLoad() {
  return function (dispatch, getState) {
    dispatch(setOperationStatus('commerce', 'orders_load', UI_OPERATION_STATUS_REQUEST));
    commerceFetch('orders/default?include=order_items', 'GET', null, dispatch, getState).then(function (response) {
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then(function (response) {
      dispatch({
        type: COMMERCE_ORDERS_DATA_RECEIVED,
        payload: response.data
      });
      dispatch(setOperationStatus('commerce', 'orders_load', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('commerce', 'orders_load', UI_OPERATION_STATUS_ERROR));
    });
  };
};